import React ,{useRef ,useEffect}from 'react';
import moment from 'moment'
import IrtizaDynamicInputList from '../dynamic-input/dynamic-input-list';
import SecurityService from '../security/security.service';
import UnitOfMeasurementService from './unit-of-measurement.service';
import AuditTableInput from '../audit-table/audit-table'
import './unit-of-measurement.scss'


const UnitOfMeasurementInput = (props) => {



// UnitOfMeasurementID
// UnitOfMeasurement
    let columns =[
        {  field: "UnitOfMeasurementID",headerText:'ID',width:'90px',textAlign:'right' ,headerTextAlign:'center',other:[{allowEditing:false}]},
        {  field: "UnitOfMeasurement",headerText:'Unit Of Measurement ',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        ]

       const listActionComplete = async (grid , args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          // if(args.requestType == 'add'){
          //   setTimeout(()=>document.getElementById('UnitOfMeasurementGridUnitOfMeasurement').focus(),400)
          // }
          document.getElementById('UnitOfMeasurementGridUnitOfMeasurement').addEventListener('blur', async (e)=>{
            setTimeout(() => document.getElementById('UnitOfMeasurementGridUnitOfMeasurement') && grid?.endEdit(), 200);
           
          })
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            id:args.data.UnitOfMeasurementID,
            value:args.data.UnitOfMeasurement
          }
          console.log(data)
        if(args.action == 'add'){
          UnitOfMeasurementService.insert(data).then(async (res)=>{
            await getListService()
            setTimeout(()=>document.getElementById('UnitOfMeasurementGrid_add').click(),700)

            // let AddData = {
            //   UnitOfMeasurementID:args.data.UnitOfMeasurementID,
            //   UnitOfMeasurement:args.data.UnitOfMeasurement,
            // }
            // AuditTableInput.auditAdd(`UnitOfMeasurement`,`UnitOfMeasurement`,`UnitOfMeasurementID`,AddData)
          })
        }
        if(args.action == 'edit'){
          UnitOfMeasurementService.update(data).then((res)=>{
            getListService()

            // let EditData = {
            //     UnitOfMeasurementID:args.data.UnitOfMeasurementID,
            //     UnitOfMeasurement:args.data.UnitOfMeasurement
            // }
            // let totalColumns = Object.keys(EditData);
            //             console.log(totalColumns)
            //             AuditTableInput.auditEdit(totalColumns,selectedRow,EditData,`UnitOfMeasurement`,args.data.MainUnitOfMeasurementID)
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = false

       
        // Defines the  string
        // @default UnitOfMeasurement${typeMode} 
        let ListSecurity='JournalVoucherList'
        let AddSecurity='JournalVoucherList'
        let EditSecurity='JournalVoucherList'
        let DeleteSecurity='JournalVoucherList'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions ='All';

      const toolbarClicking =  async (args)=>{
        console.log(args)
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'UnitOfMeasurement' ,
                    TableID:'UnitOfMeasurementID',
                   // Optional if Delete is Soft // TableSecurity:'UnitOfMeasurementDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'UnitOfMeasurement' ,TableID:'UnitOfMeasurementID', Optional // TableSecurity:'UnitOfMeasurementDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Normal';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <IrtizaDynamicInputList
        Id='UnitOfMeasurement'
        ListTitle='Unit Of Measurement  - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        // DataSource:  ()=> UnitOfMeasurementService.getUnitOfMeasurementForList()
                        DataSource:  ()=> UnitOfMeasurementService.getUnitOfMeasurementForList()
                        }]}
        DefaultSortedColumnName={'UnitOfMeasurementID'}
        // GridDialog={[
        //     {
        //         DialogType:'Self',
        //         Dialog:<UnitOfMeasurementAdd ShopID={SecurityService.getLoggedInShopID()} />
        
        //     }
        // ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            // ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            {...props}
            ></IrtizaDynamicInputList>
            
            );
}



export default UnitOfMeasurementInput;
